import { Helmet } from "react-helmet-async";
import PageLayout from "@/components/layout/PageLayout";

const Imprint = () => {
  return (
    <PageLayout>
      <Helmet>
        <title>Impressum – NextInvoice</title>
        <meta name="description" content="Impressum von NextInvoice – Betreiber: Lizenzwerk24, Inh. Dustin Lailach, Neugersdorf." />
        <link rel="canonical" href="https://nxtinvoice.de/impressum" />
        <script type="application/ld+json">{JSON.stringify({
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          "itemListElement": [
            { "@type": "ListItem", "position": 1, "name": "Startseite", "item": "https://nxtinvoice.de/" },
            { "@type": "ListItem", "position": 2, "name": "Impressum" }
          ]
        })}</script>
      </Helmet>
      <section className="bg-background py-20 lg:py-28">
        <div className="container">
          <div className="mx-auto max-w-3xl">
            <h1 className="mb-8 font-display text-4xl font-bold text-foreground">Impressum</h1>
            
            <div className="space-y-8 text-muted-foreground">
              <div>
                <h2 className="mb-3 font-display text-xl font-bold text-foreground">Angaben gemäß § 5 DDG (Digitale-Dienste-Gesetz)</h2>
              </div>

              <div>
                <h2 className="mb-3 font-display text-xl font-bold text-foreground">Betreiber dieser Website</h2>
                <p>
                  Lizenzwerk24<br />
                  Inh. Dustin Lailach<br />
                  Hauptstraße 56<br />
                  02727 Neugersdorf, Sachsen, Deutschland
                </p>
              </div>
              
              <div>
                <h2 className="mb-3 font-display text-xl font-bold text-foreground">Kontakt</h2>
                <p>
                  Telefon: <a href="tel:+4915565350880" className="text-primary hover:underline">+49 15565 350880</a><br />
                  E-Mail: <a href="mailto:Legal@NxtInvoice.de" className="text-primary hover:underline">Legal@NxtInvoice.de</a><br />
                  E-Mail: <a href="mailto:Legal@lizenzwerk24.de" className="text-primary hover:underline">Legal@lizenzwerk24.de</a>
                </p>
                <p className="mt-2 text-sm">
                  Nach §28 BDSG widerspreche ich jeder kommerziellen Verwendung und Weitergabe meiner Daten.
                </p>
              </div>
              
              <div>
                <h2 className="mb-3 font-display text-xl font-bold text-foreground">Steuerliche Angaben</h2>
                <p>Kleinunternehmer gemäß § 19 UStG. Es wird keine Umsatzsteuer erhoben und ausgewiesen.</p>
              </div>

              <div>
                <h2 className="mb-3 font-display text-xl font-bold text-foreground">Hinweis zum Produkt „NextInvoice"</h2>
                <p>
                  Diese Website wird betrieben von Lizenzwerk24, Inh. Dustin Lailach, als autorisierter Vertriebspartner für das Produkt NextInvoice.
                </p>
                <p className="mt-3">
                  Das Produkt NextInvoice sowie alle damit verbundenen Produkt-, Software- und Markenrechte sind ausschließliches Eigentum von:
                </p>
                <p className="mt-3 rounded-xl border border-border bg-muted/50 p-4">
                  Launix Inh. Carl-Philip Hänsch<br />
                  Liechtensteinstr. 17<br />
                  02727 Ebersbach-Neugersdorf<br />
                  E-Mail: <a href="mailto:impr@launix.de" className="text-primary hover:underline">impr@launix.de</a><br />
                  USt-IdNr.: DE285007269
                </p>
                <p className="mt-2 text-sm">
                  Nach §28 BDSG widerspreche ich jeder kommerziellen Verwendung und Weitergabe meiner Daten.
                </p>
                <p className="mt-3">
                  Lizenzwerk24 handelt ausschließlich als autorisierter Vertriebspartner und ist nicht Hersteller, Rechteinhaber oder Entwickler des Produkts NextInvoice.
                </p>
              </div>

              <div>
                <h2 className="mb-3 font-display text-xl font-bold text-foreground">Verantwortlich für den Inhalt gemäß § 18 Abs. 2 MStV</h2>
                <p>
                  Dustin Lailach<br />
                  Hauptstraße 56<br />
                  02727 Neugersdorf, Sachsen, Deutschland
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </PageLayout>
  );
};

export default Imprint;
